import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase } from '../../styles/icon';
import { MODES } from './constants';
import { TransitionConfig } from '../../constants/styles-config';

export const ColorInner = styled.span`
  display: block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  
  ${({ color }) => `
    background-color: ${color};
  `}
`;

export const Icon = styled(IconBase)`
  font-size: 24px;
  line-height: 24px;
  vertical-align: 6px;
  cursor: pointer;
  
  &:before {
    margin-left: 0;
    margin-right: 0;
  }
  
  &:hover {
    color: ${Colors.violet};
  }
`;

export const SelectOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 30px;
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  color: ${Colors.shade07};
  text-align: center;
  line-height: 60px;
  
  ${Icon} {
    font-size: 34px;
    vertical-align: -7px;
  }
`;

const Container = styled.span`
  position: relative;
  display: inline-block;
  height: 28px;
  width: auto;
  border-radius: 14px;
  background-color: ${Colors.shade05};
  ${({ mode }) => (mode === MODES.DELETE ? `
    display: inline-flex;
    align-items: center;
  ` : 'display: inline-block;')}

  ${({ large, huge }) => {
    if (large) {
      return `
        height: 40px;
        border-radius: 20px;
        
        ${ColorInner} {
          display: inline-block;
          height: 40px;
          width: 40px;
        }
        
        ${Icon} {
          margin-right: 4px;
          vertical-align: 12px;
        }
      `;
    }
    if (huge) {
      return `
        height: 60px;
        border-radius: 30px;
        
        ${ColorInner} {
          display: inline-block;
          height: 60px;
          width: 60px;
        }
      `;
    }
    return '';
  }}
  
  ${({ selectAction }) => {
    if (selectAction) {
      return `
        cursor: pointer;
        
        ${SelectOverlay} {
          opacity: 0;
          transition: opacity ${TransitionConfig};
          
          ${Icon} {
            opacity: 0.8;
            pointer-events: none;
          }
        }
  
        &:hover {
          ${SelectOverlay} {
            opacity: 1;
          }
        }
      `;
    }
    return '';
  }}

  ${({ isSelected }) => {
    if (isSelected) {
      return `    
        ${SelectOverlay} {
          opacity: 1;
          ${Icon} {
            opacity: 1;
          }
        }
      `;
    }
    return '';
  }}
`;

export {
  // eslint-disable-next-line import/prefer-default-export
  Container,
};
